import { Contract } from 'ethers';
import { ERC20Interface } from '../constants';
import { useCall } from './useCall';
/**
 * @public
 */
export function useTokenBalance(tokenAddress, address, queryParams = {}) {
    var _a;
    const { value: tokenBalance } = (_a = useCall(address &&
        tokenAddress && {
        contract: new Contract(tokenAddress, ERC20Interface),
        method: 'balanceOf',
        args: [address],
    }, queryParams)) !== null && _a !== void 0 ? _a : {};
    return tokenBalance === null || tokenBalance === void 0 ? void 0 : tokenBalance[0];
}
//# sourceMappingURL=useTokenBalance.js.map